import './landingpage.css'
import { useState, useEffect } from 'react';
import CardCarousel from 'react-bootstrap/Carousel';
import Carousel from "react-elastic-carousel";
import ReferSignIn from '../SignIn/ReferSignIn';
import history from '../../History/history';
import { useSearchParams,Link } from 'react-router-dom';
import ReactPlayer from 'react-player/youtube'
import goal from '../../assets/IPOlandingpage/goal_circle.png'
import rupee from '../../assets/IPOlandingpage/rupee_circle.png'
import downarrow from'../../assets/IPOlandingpage/down-arrow-white.svg'
import soldropdown from '../../assets/IPOlandingpage/our_solutions_drop-down.svg'
import mfs from '../../assets/IPOlandingpage/header-mfs.svg'
import gbs from '../../assets/IPOlandingpage/header-gbs.svg'
import cr from '../../assets/IPOlandingpage/header-cr.svg'
import pwm from '../../assets/IPOlandingpage/header-pwm.svg'
import nps from '../../assets/IPOlandingpage/header-nps.svg'
import alter from '../../assets/IPOlandingpage/header-alter.svg'
import gfs from '../../assets/IPOlandingpage/header-gfs.svg'
import toggle from '../../assets/IPOlandingpage/hamburger.svg'
import globe from '../../assets/IPOlandingpage/globe.svg'
import malaysia from '../../assets/IPOlandingpage/malaysia.svg'
import international from '../../assets/IPOlandingpage/international.svg'
import AOS from 'aos'

const LandingPage = () => {

  const [openSol,setOpenSol] = useState(false);

  const toggleHandler = (eve) => {
    eve.preventDefault();
    setOpenSol(!openSol)
  }

  const showDropdown = (eve) => {
    eve.preventDefault();
    document.getElementById("content").classList.toggle("show");
  }

  useEffect(() => {
    AOS.init()
  },[])

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];

  const getFullScreen = () => {
    const element = document.getElementById("player");
        
   element.requestFullscreen();
  }
 
  return (  <>
  <header>
   <div className='header' style={{backgroundColor: 'rgb(12, 11, 12)'}}>
    <nav className='navbar navbar-expand-md navbar-light'>
      <div className='container-fluid justify-content-center'>
        <a className='navbar-brand' href='https://www.kfintech.com/'>
          <img src='https://risop.kfintech.com/ris-assets/images/logo/kfintech-white-tagline.svg' alt='' className='logo' data-aos="fade-up"  data-aos-delay="250" />{' '}
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
          <img className="toggle-open" src={toggle} alt="hamburger icon" />
         
        </button>

        <div
          className='collapse navbar-collapse justify-content-md-end mobilenav'
          id='navbarNavDropdown'
        >
          <ul className='navbar-nav'>
          <li className="nav-item" data-aos="fade-up" data-aos-delay="500">
          <a className="nav-link" href='#' style={{color:'white'}} onClick={toggleHandler} >
            Solutions
            <img src={downarrow} alt="icon" />
          </a>

        </li>

            <li className='nav-item' data-aos="fade-up" data-aos-delay="550">
              <a
                className='nav-link '
                style={{color:'white'}}
                target='_blank'
                href='https://kfintech.com/products/'
              >
                Products
              </a>
            </li>

            <li className='nav-item' data-aos="fade-up" data-aos-delay="750">
              <a
                className='nav-link'
                style={{color:'white'}}
                target='_blank'
                href='https://www.kfintech.com/about-us/'
              >
                About Us
              </a>
            </li>

            <li className='nav-item' data-aos="fade-up" data-aos-delay="1000" >
              <a
                className='nav-link'
                style={{color:'white'}}
                target='_blank'
                href='https://careers.kfintech.com/'
              >
                Careers
              </a>
            </li>

            <li className='nav-item' data-aos="fade-up" data-aos-delay="1250">
              <a
                className='nav-link'
                style={{color:'white'}}
                target='_blank'
                href='https://www.kfintech.com/contact-us/'
              >
                Contact Us
              </a>
            </li>

            <li className="nav-item dropdown" data-aos="fade-up" data-aos-delay="1250">
              <a className="nav-link dropdown" href="#" data-toggle="dropdown" onClick={showDropdown} ><img
                  src={globe} alt="icon" /><img src={downarrow}
                  alt="icon" /></a>
              <div className="dropdown-menu" id="content" style={{backgroundColor:'rgb(12, 11, 12)'}}>
                <a className="dropdown-item" href="https://www.kfintech.com/gfs-malaysia/"><img
                    src={malaysia} alt="icon" />Visit Malaysia</a>
                <a className="dropdown-item" href="https://www.kfintech.com"><img src={international}
                    alt="icon" />Stay on International</a>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  </div>
  </header>

  {
    openSol ? 

    <div className='px-5' style={{backgroundColor: 'rgb(12, 11, 12)'}}>
    <div className="row"style={{backgroundColor: 'rgb(12, 11, 12)'}}>
    <div className="col-md-3">
      <div className="sub-menu-left">
        <h3>Our Solutions</h3>
        <p>
          Our services and solutions provide trust through assurance and help clients transform, grow and
          operate.
        </p>
        <img src={soldropdown} alt="icon" />
      </div>
    </div>
    <div className="col-sm-12 col-md-9 row">
      <ul className='sub-menu-ul'>
        <li className='sub-menu-ul-li'>
          <a className='anchor'  href="https://mfs.kfintech.com/mfs/" target="_blank">
            <div className="sub-menu-icon">
              <img src={mfs} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Mutual Fund Solutions</h5>
              <p>Ensuring ease of Investors across platforms</p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://globalbusinessservices.kfintech.com/" target="_blank">
            <div className="sub-menu-icon">
              <img src={gbs} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Global Business Solutions</h5>
              <p>Efficient & Effective optimization of resources</p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://ris.kfintech.com/" target="_blank">
            <div className="sub-menu-icon">
              <img src={cr} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Corporate Registry</h5>
              <p>Curating Innovative and tech driven services</p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://www.kfintech.com/private-wealth-management/" target="_blank">
            <div className="sub-menu-icon">
              <img src={pwm} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Private Wealth Management</h5>
              <p>
                Perfect solution gateway for portfolio Information
              </p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://enps.kfintech.com/" target="_blank">
            <div className="sub-menu-icon">
              <img src={nps} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>National Pension system</h5>
              <p>Smartly segregating savings and spending</p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://www.kfintech.com/alternate-investment-fund/" target="_blank">
            <div className="sub-menu-icon">
              <img src={alter} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Alternatives</h5>
              <p>
                One place for End-to-End Financial management
                solutions.
              </p>
            </div>
          </a>
        </li>
        <li className='sub-menu-ul-li'>
          <a className='anchor' href="https://www.kfintech.com/gfs-malaysia/" target="_blank">
            <div className="sub-menu-icon">
              <img src={gfs} alt="icon" />
            </div>
            <div className="sub-menu-text">
              <h5>Global Fund Solutions</h5>
              <p>Serving world class services across schemes</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
  </div>
  
  : ''
  }

    <div className='div1 pt-5'>
      <div className='container'>
      <div className="col-lg-6 " style={{paddingTop: '10%'}}>
                    <h1  style={{color:'white'}}>Initial Public Offer</h1>
                    <p className="lead text-secondary mb-5">Choose from an assortment of asset classes & enjoy the freedom of investing</p>
                    <Link to="/refer-signIn"> <button className="btn  btn-lg border" style={{backgroundImage:'  linear-gradient(#0090FF , #36DAE9)', color:'white'}} onClick={() => history.push('/refer_signIn')}>Refer Now</button></Link>
        </div>
      </div>
    </div>

    <div style={{backgroundColor:'black',height:'auto'}}>
    <h3 className='py-5 text-center'  style={{color:'white'}}>Benefits</h3>
    <div className='container'>
      <div className='row' >
    
    <div className='col-md-6'>
     
        <div className='card' style={{margin:'10%', height:'150px'}}>
        <div className="card-body" style={{color:'rgb(19, 183, 216)',textAlign:'justify',backgroundImage:'linear-gradient(rgb(4, 58, 80), black)'}}>   
        <h5 className='mt-4' style={{fontWeight:'600',textAlign:'center'}}> Earn Unlimited</h5>
        <div className="overlay">
        <div className='rupee-icon' title="Video Play">
            < img src={rupee}></img>
        </div>
        </div>
        </div>    
        </div>

        </div>
    
        <div className='col-md-6'>
        <div className='card ' style={{margin:'10%', height:'150px'}}>
        <div className="card-body" style={{color:'rgb(19, 183, 216)',textAlign:'center',backgroundImage:'linear-gradient(rgb(4, 58, 80), black)'}}>   
        <h5 className='mt-3' style={{fontWeight:'500'}}> Help your friends to open<br/> a Demat account</h5>
        <div className="overlay">
        <div className='goal-icon' title="Video Play">
            < img src={goal}></img>
        </div>
        </div>  
        </div>  
        </div>
      </div> 

      </div>    
      </div>

        <h3 className='py-5 text-center'  style={{color:'white'}}>How does it work</h3> 
     
   <div className='mx-5'>     
  <div className='row'>      
  <div className='col-md-6'>
           <div className='player-wrapper'>    
           <ReactPlayer
           controls
           id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=tJ0oM_r1ZQA'
          width='100%'
           height='100%'
           onStart={getFullScreen} /> 
           </div>
           </div>
           
          <div className='col-md-6' >
             <p style={{textAlign:'left', width:'100%',fontSize:'18px',fontWeight:'300px', height:'100%',color:'white', overflow:'auto'}}><br/>You have the opportunity to earn ₹400 on every successful Demat Account opened. There is no stopping, you can refer unlimited number of people to open a Demat Account using your referral link and that will be the path towards unlimited income! 
               <br/><br/>Start earning in 3 easy steps:<br/>1. Share your unique referral link with friends.<br/> 2. Your friend opens a Demat Account using your referral link <br/> 3. You earn up to ₹400 on each referral Your friend trades on ipo.kfintech.com and can refer further to gain referral income for himself/herself!</p>
      </div>
       </div>
       </div>
     
          <h3 className='pt-5 text-center' style={{color:'white'}}>Demat Account Opening Process </h3>
        <div className='pb-3'>
          <div className='mt-5'>
        <Carousel  breakPoints={breakPoints}>
          <div style={{width:'90%'}}>
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>

          <ReactPlayer
          className = 'react-player'
          controls
          id= 'player'
           url='https://www.youtube.com/watch?v=-9T0eaWKo6c'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
         
          </div>
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Zerodha</p>
          </div>

          <div style={{width:'90%'}}>
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
          className = 'react-player'
          id= 'player'
           url='https://www.youtube.com/watch?v=oUAImE1IAXA'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
          </div>
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Ventura Securities</p>
          </div>

          <div style={{width:'90%'}}>
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
          id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=7kbpmJLYhz0'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
           </div>
           <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Religare</p>
          </div>

          {/* <div style={{width:'90%'}}>
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
            id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=uG3ZfwTNbUA'
          width='100%'
           height='100%' 
           onStart={getFullScreen}/>
          </div>
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Marwadi Financial Services</p>
          </div> */}

          <div style={{width:'90%'}}>
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
            id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=LTxuu9vlC3I'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
           </div> 
           <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Kotak Securities</p>
           </div>    

          <div style={{width:'90%'}}>   
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
            id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=4U4Jle1Gshg'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
          </div>
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with HDFC Securities</p>
          </div>

          <div style={{width:'90%'}}>   
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
            id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=4Bm5Zg8_Jjc'
          width='100%'
           height='100%'
           onStart={getFullScreen} />
          </div>
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Bajaj FinServ</p>
          </div>

          <div style={{width:'90%'}}> 
          <div className='card  bg-light' style={{height:'200px',width:'100%'}}>
          <ReactPlayer
            id= 'player'
          className = 'react-player'
           url='https://www.youtube.com/watch?v=gdwzrys6XI8'
          width='100%'
           height='100%'
           onStart={getFullScreen} />  
          </div>  
          <p className='text-center' style={{color:'white', fontSize:'20px', }}>Open Demat Account with Axis Securities</p>
          </div>              
       </Carousel >
       </div>
        </div>
    </div>
    
  


 
  </>);
}
export default LandingPage;